<template>
  <div class="box">
    <div v-html="service_agreement"></div>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：隐私政策
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-05-23 18:25
 */
export default {
  data() {
    return {
      service_agreement: "",
    };
  },
  mounted() {
    document.title = "用户协议";
    let type = this.$route.query.type; // 1:商家  2:技师
    let url, data;
    if (type == 1) {
      url = `${this.$root.baseUrlTwo}/baselogin/agreement`;
      data = {
        type: 1,
      };
    } else if (type == 2) {
      url = `${this.$root.baseUrlTwo}/baselogin/agreement`;
      data = {
        type: 2,
      };
    }
    this.$axios({
      method: "post",
      headers: {
        "Content-Type": "application/json",
        // "Content-Type": "application/x-www-form-urlencoded",
      }, // 请求头
      url: url,
      data: data,
    }).then((result) => {
      this.service_agreement = result.data.data.service_agreement; // 用户头像
    });
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.box {
  padding: 20px;
}

::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>